export default "__VITE_ASSET__WHZeLxiK__"